import {
  Box,
  Center,
  Heading,
  SimpleGrid,
  GridItem,
  Grid,
  Flex,
  Stack,
  Text,
  useColorModeValue as mode,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  FormControl,
  Input,
  ModalCloseButton,
  FormLabel,
  ModalFooter,
  Img,
  theme,
  Button,
  List,
  ListItem,
  ListIcon,
  OrderedList,
  UnorderedList,
  TagLabel,
  Tag,
  Icon,
  HStack,
} from "@chakra-ui/react";
import { Logo } from "components/logo";
import * as React from "react";
import { PricingCard } from "./pricing-card";
import { useSession } from "next-auth/react";
import { useRouter } from "next/dist/client/router";
import { firebaseClient } from "../../firebaseClient";
import * as analytics from "../../utils/analytics";
import {
  updateEmail,
  guessTimezone,
  initUserAnalytics,
} from "../../controllers/settings";
import { warm } from "../../controllers/search";
import { getPeriodicity, getPlan } from "../../controllers/subscription";
import ShoutoutEmbed from "shoutout-react";
import { MdCheckCircle } from "react-icons/md";
import Payment from "components/payment";
import { SocialProof } from "../social-proof";
import { GiftGuide } from "../gift-guide";
import { prices, discounts } from "./pricing";
import { getAccount } from "utils/sessionHelper";
import { planAndTargetUsersMapping, useCampaign } from "hooks/useCampaign";

let now = new Date();
// let now = new Date(2021,8,18,0,0,0);
let startCounterDate = new Date(2021, 11, 25, 0, 0, 0);
let endCounterDate = new Date(2021, 11, 25, 23, 59, 59);
let diffDate = endCounterDate.getTime() - startCounterDate.getTime();
let startCount = 92;
let endCount = 7;

const specialDiscounts = [
  { code: "GROWINGACCOUNT", message: "< 1000 followers? Get 50% off GROW" },
  { code: "PRATHAM", message: "Special offer for Pratham's friends 👋" },
  { code: "GROWAT29", message: "Enjoy a unique offer" },
  {
    code: "VIPOFFER",
    message: "VIP detected - enjoy a unique offer",
    monthlyOnly: true,
    startPriceOverride: 1,
    growPriceOverride: 1,
    specialNoticeStart: "for 1 month, then $49",
    specialNoticeGrow: "for 1 month, then $49",
  },
  {
    code: "PRODUCTHUNT",
    message: "Welcome PH - enjoy a unique offer",
    monthlyOnly: true,
    startPriceOverride: 1,
    growPriceOverride: 1,
    specialNoticeStart: "for 1 month, then $49",
    specialNoticeGrow: "for 1 month, then $49",
  },
  {
    code: "THEPUP",
    message: "Welcome Danny's friend",
    monthlyOnly: true,
    startPriceOverride: 1,
    growPriceOverride: 1,
    specialNoticeStart: "for 1 month, then $49",
    specialNoticeGrow: "for 1 month, then $49",
  },
];

function PricingCardFeatureIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3103 5.27863V5.75479C11.3097 6.87088 10.9483 7.95686 10.28 8.85078C9.61173 9.74469 8.67241 10.3986 7.60212 10.7151C6.53184 11.0315 5.38793 10.9935 4.341 10.6068C3.29408 10.22 2.40023 9.50512 1.79276 8.56883C1.1853 7.63254 0.896768 6.52496 0.970204 5.41129C1.04364 4.29762 1.4751 3.23752 2.20025 2.3891C2.9254 1.54068 3.90537 0.949392 4.99402 0.703426C6.08267 0.45746 7.22167 0.569993 8.24113 1.02424"
        stroke="currentColor"
        strokeWidth="1.03513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3104 1.61523L6.13473 6.79607L4.58203 5.24337"
        stroke="currentColor"
        strokeWidth="1.03513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PricingCard1({
  discount,
  billingFrequency,
  startPlanPrice,
  specialNoticeStart,
  onClickStartFreeTrial,
  customCancelUrl,
}) {
  return (
    <GridItem mb={[4, 4, 10]} colSpan={1}>
      <PricingCard
        name="Starter"
        plan="start"
        description="Start publishing high performing content on a daily basis and spend 5x less time doing so."
        discount={discount}
        billingFrequency={billingFrequency}
        price={startPlanPrice}
        specialNotice={specialNoticeStart} //@ts-ignore
        onClickStartFreeTrial={onClickStartFreeTrial}
        customCancelUrl={customCancelUrl}
        features={[
          {
            isTitle: true,
            icon: <>💡</>,
            label: "Content Inspiration",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "4M+ viral posts library",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "AI-picked suggestions",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "AI-generated posts",
            isDisabled: true,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "On-demand AI post generator",
            isDisabled: true,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "On-demand AI hook generator",
            isDisabled: true,
            details: "",
          },
          {
            isTitle: true,
            icon: <>📅</>,
            label: "Advanced Scheduling",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Post composer w/ images & carousels",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "High-fidelity post previews",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Smart “1-click” scheduling",
            isDisabled: false,
            details: "",
          },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Auto DM, Auto Plug, Hide URL expands",
          //   isDisabled: false,
          //   details: "",
          // },
          {
            isTitle: true,
            icon: <>🤝</>,
            label: "Relationship Builder",
            isDisabled: true,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "import from Sales Navigator",
            isDisabled: true,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Automatically import likers and commenters ",
            isDisabled: true,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Manually import likers and commenters of ANY post",
            isDisabled: true,
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Reply to other people’s posts ",
            isDisabled: true,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "AI-generated comments ",
            isDisabled: true,
            details: "",
          },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Send personalized DMs in bulk ",
          //   isDisabled: true,
          //   details: "",
          // },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Integrate with your CRM w/ Zapier",
            isDisabled: true,
            details: "",
          },
          {
            isTitle: true,
            icon: <>📊</>,
            label: "Actionable Analytics (solo)",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Your main KPIs at a glance",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Detailed post performance",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Team and organization stats",
            isDisabled: true,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Highly shareable analytics screenshots",
            isDisabled: false,
            details: "",
          },
        ]}
      />
    </GridItem>
  );
}

function PricingCard2({
  discount,
  billingFrequency,
  startPlanPrice,
  specialNoticeStart,
  onClickStartFreeTrial,
  customCancelUrl,
  growDiscount,
  growPlanPrice,
  withCounter = false,
  poweredByGPT4 = false,
  includesChatAssist = false,
  discountedFrom = "",
}) {
  // console.log({withCounter});
  return (
    <GridItem colSpan={1} mt={[-10, -10, 0]}>
      {/*
        promotion?.message && (
          <Center>
            <Tag
              mb={5}
              p={2}
              pl={4}
              pr={4}
              bg={mode("gray.800", "white")}
              borderRadius="full"
              size="md"
            >
              <TagLabel
                fontSize="md"
                fontWeight="400"
                color={mode("white", "gray.700")}
              >
                {promotion?.message}
              </TagLabel>
            </Tag>
          </Center>
        )
        */}
      <PricingCard
        name="Standard"
        plan="grow"
        description="Unlock the power of relationship building, AI-generated posts and team analytics."
        // top="76% pick this plan"
        discount={growDiscount}
        billingFrequency={billingFrequency}
        popular={true}
        price={growPlanPrice}
        // discountedFrom={billingFrequency === "monthly" ? "99" : "79"}
        discountedFrom={discountedFrom}
        poweredByGPT4={poweredByGPT4}
        includesChatAssist={includesChatAssist}
        // specialNotice={"For the next 19 people to sign up"} // specialNotice={specialNoticeGrow}
        // specialNotice={isSmallAccount ? "Discount less than 1000 followers" : ""}
        features={[
          {
            isTitle: true,
            icon: <>💡</>,
            label: "Content Inspiration",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "4M+ viral posts library",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "AI-picked suggestions",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "AI-generated posts",
            isDisabled: false,
            details: "",
            isAi: true,
            isBold: true,
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "On-demand AI post generator",
            isDisabled: false,
            details: "",
            isBold: true,
            isAi: true,
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "On-demand AI hook generator",
            isDisabled: false,
            details: "",
            isBold: true,
            isAi: true,
          },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "On-demand AI post generator",
          //   isDisabled: false,
          //   details: "",
          //   isBold: true,
          // },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "On-demand AI hook generator",
          //   isDisabled: false,
          //   details: "",
          //   isBold: true,
          // },
          {
            isTitle: true,
            icon: <>📅</>,
            label: "Advanced Scheduling",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Post composer w/ images & carousels",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "High-fidelity post previews",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Smart “1-click” scheduling",
            isDisabled: false,
            details: "",
          },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Auto DM, Auto Plug, Hide URL expands",
          //   isDisabled: false,
          //   details: "",
          // },
          {
            isTitle: true,
            icon: <>🤝</>,
            label: "Relationship Builder",
            isDisabled: false,
            details: "",
          },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Import people from posts & Sales Nav searches",
          //   isDisabled: false,
          //   details: "Up to 100 people per post.",
          //   isBold: true,
          // },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Automatically import likers and commenters",
          //   isDisabled: false,
          //   details: "Up to 10 likers or commenters per post",
          //   isBold: true,
          // },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Manually import likers and commenters of ANY post",
          //   isDisabled: false,
          //   details: "Up to 100 people / post",
          //   isBold: true,
          // },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Reply to comments & other people’s posts",
            isDisabled: false,
            details: "Up to 100 comments / month.",
            isBold: true,
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "AI-generated comments ",
            isDisabled: false,
            details: "",
            isBold: true,
            isAi: true,
          },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Send personalized DMs in bulk ",
          //   isDisabled: false,
          //   details: "",
          //   isBold: true,
          // },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Integrate with your CRM w/ Zapier",
            isDisabled: false,
            details: "",
            isBold: true,
          },
          {
            isTitle: true,
            icon: <>📊</>,
            label: "Actionable Analytics",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Your main KPIs at a glance",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Detailed post performance",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Team and organization stats",
            isDisabled: false,
            details: "",
            isBold: true,
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Highly shareable analytics screenshots",
            isDisabled: false,
            details: "",
          },
        ]} //@ts-ignore
        onClickStartFreeTrial={onClickStartFreeTrial}
        customCancelUrl={customCancelUrl}
        withCounter={withCounter}
        bottomContent={
          <>
            <Box
              {...{
                mt: 4,
                bg: "white",
                borderRadius: "lg",
                bgGradient: "linear(to-r, #CD6C8E, #7B6BCA)",
                p: 4,

                color: "white",
                textAlign: "center",
              }}
            >
              <Box
                {...{
                  fontSize: "12.5px",
                  fontWeight: 700,
                }}
              >
                250 GPT-4 credits/mo
              </Box>
              <Box
                {...{
                  fontSize: "10px",
                  fontWeight: 500,
                }}
              >
                and{" "}
                <Box
                  as="span"
                  textDecor={"underline"}
                  textUnderlineOffset={"2px"}
                >
                  unlimited
                </Box>{" "}
                GPT-3.5 credits after that
              </Box>
            </Box>
            <Box
              {...{
                textAlign: "center",
                fontStyle: "italic",
                fontSize: "10px",
                px: 6,
                mt: 4,
              }}
            >
              GPT-4 is the most advanced commercially available AI model,
              provided by OpenAI.
            </Box>
          </>
        }
      />
    </GridItem>
  );
}

function PricingCard3({
  discount,
  billingFrequency,
  startPlanPrice,
  specialNoticeStart,
  onClickStartFreeTrial,
  customCancelUrl,
  enterprisePlanPrice,
  poweredByGPT4 = false,
  includesChatAssist = false,
  discountedFrom = "",
}) {
  const router = useRouter();
  return (
    <GridItem colSpan={1} mt={[-10, -10, 0]} maxW={"345px"}>
      <PricingCard
        name="Pro"
        plan="enterprise"
        description="Access all our relationship building features with no limits. Ideal for large accounts."
        discount={discount}
        discountedFrom={discountedFrom} //router?.pathname?.includes("/pricing") ? "208" : ""
        billingFrequency={billingFrequency}
        price={enterprisePlanPrice}
        poweredByGPT4={poweredByGPT4}
        includesChatAssist={includesChatAssist}
        includesDatabase={true}
        features={[
          {
            isTitle: true,
            icon: <>💡</>,
            label: "Content Inspiration",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "4M+ viral posts library",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "AI-picked suggestions",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "AI-generated posts",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "On-demand AI post generator",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "On-demand AI hook generator",
            isDisabled: false,
            details: "",
          },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "On-demand AI post generator",
          //   isDisabled: false,
          //   details: "",
          // },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "On-demand AI hook generator",
          //   isDisabled: false,
          //   details: "",
          // },
          {
            isTitle: true,
            icon: <>📅</>,
            label: "Advanced Scheduling",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Post composer w/ images & carousels",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "High-fidelity post previews",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Smart “1-click” scheduling",
            isDisabled: false,
            details: "",
          },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Auto DM, Auto Plug, Hide URL expands",
          //   isDisabled: false,
          //   details: "",
          // },
          {
            isTitle: true,
            icon: <>🤝</>,
            label: "Relationship Builder (pro)",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label:
              "Database | find relevant leads within millions of accounts ",
            isDisabled: false,
          },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Import people from posts & Sales Nav searches ",
          //   isDisabled: false,
          //   details: "Up to 500 people per post",
          // },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Automatically import likers and commenters ",
          //   isDisabled: false,
          //   details: "Up to 100 likers or commenters per post.",
          //   isDetailsBold: true,
          // },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Manually import likers and commenters of ANY post",
          //   isDisabled: false,
          //   details: "Up to 500 people / post",
          //   isDetailsBold: true,
          // },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Reply to comments & other people’s posts",
            isDisabled: false,
            details: "Up to 1500 comments / month",
            isDetailsBold: true,
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "AI-generated comments ",
            isDisabled: false,
            details: "",
          },
          // {
          //   isTitle: false,
          //   icon: <PricingCardFeatureIcon />,
          //   label: "Send personalized DMs in bulk ",
          //   isDisabled: false,
          //   details: "",
          // },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Integrate with your CRM w/ Zapier",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: true,
            icon: <>📊</>,
            label: "Actionable Analytics",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Your main KPIs at a glance",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Detailed post performance",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Team and organization stats",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Highly shareable analytics screenshots",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: true,
            icon: <>👨‍🔧</>,
            label: "Pro Support",
            isDisabled: false,
            details: "",
          },
          {
            isTitle: false,
            icon: <PricingCardFeatureIcon />,
            label: "Assistance with team account management and billing",
            isDisabled: false,
            details: "",
          },
        ]}
        // @ts-ignore
        onClickStartFreeTrial={onClickStartFreeTrial}
        customCancelUrl={customCancelUrl}
        bottomContent={
          <>
            <Box
              {...{
                mt: 4,
                bg: "white",
                borderRadius: "lg",
                bgGradient: "linear(to-r, #CD6C8E, #7B6BCA)",
                p: 4,

                color: "white",
                textAlign: "center",
              }}
            >
              <Box
                {...{
                  fontSize: "12.5px",
                  fontWeight: 700,
                }}
              >
                5,000 GPT-4 credits/mo
              </Box>
              <Box
                {...{
                  fontSize: "10px",
                  fontWeight: 500,
                }}
              >
                and{" "}
                <Box
                  as="span"
                  textDecor={"underline"}
                  textUnderlineOffset={"2px"}
                >
                  unlimited
                </Box>{" "}
                GPT-3.5 credits after that
              </Box>
            </Box>
            <Box
              {...{
                textAlign: "center",
                fontStyle: "italic",
                fontSize: "10px",
                px: 6,
                mt: 4,
              }}
            >
              GPT-4 is the most advanced commercially available AI model,
              provided by OpenAI.
            </Box>
          </>
        }
      />
    </GridItem>
  );
}

export const Plans = ({
  discount,
  billingFrequency,
  customCancelUrl = undefined as string | undefined,
  isFromIndia = false,
  withCounter = false,
  ...rest
}) => {
  const { data: session, status } = useSession() ?? {};
  const loading = status === "loading";
  const { activeCampaign } = useCampaign();
  // console.log({ withCounter });

  const originalDiscount = discount;
  // handle url like ...utm_source=bfcmjk&discount=VIPOFFER&discount=VIPOFFER
  if (discount && Array.isArray(discount) && discount.length > 0) {
    discount = discount[0];
  }
  const isMonthly = billingFrequency === "monthly";

  let startPlanPrice = isMonthly
    ? prices.start.monthly.default
    : prices.start.yearly.default;
  let growPlanPrice = isMonthly
    ? prices.grow.monthly.default
    : prices.grow.yearly.default;
  let enterprisePlanPrice = isMonthly
    ? prices.enterprise.monthly.default
    : prices.enterprise.yearly.default;

  let specialNoticeGrow = "";
  let specialNoticeStart = "";
  let growDiscount = discount || "";

  // console.log("discount: " + discount);
  var promotion = specialDiscounts.find((x) => x.code == discount) as any;
  let isSmallAccount =
    session?.user?.data?.followers_count &&
    session?.user?.data?.followers_count < 1000;

  var globalPromotion;
  // to activate when you want a counter
  // let ratio = (now.getTime() - startCounterDate.getTime()) / diffDate;
  // let counter = Math.round(startCount - (ratio * (startCount-endCount)));
  // console.log("ratio: " + ratio);
  // console.log("counter: " + counter);
  // if (now > startCounterDate && now < endCounterDate) {
  //     globalPromotion = {code: "", message: (<Text whiteSpace="pre-line"><b>{"X-Mas special\n"}</b><b>{`${counter}/99 Tweet Hunter University enrollments left`}</b></Text>)};
  // }
  // globalPromotion = {
  //   code: "",
  //   message: (
  //     <Text whiteSpace="pre-line">
  //       <Text as="span" fontWeight="800" fontSize="xl">
  //         {"BLACK FRIDAY\n"}
  //       </Text>
  //       <b>{`Get an extra 50% off on YEARLY plans. Yes, 50%. Use code BLACKFRIDAY at checkout.`}</b>
  //     </Text>
  //   ),
  // };

  if (isSmallAccount && !discount && !promotion && !isFromIndia) {
    growPlanPrice = isMonthly
      ? prices.grow.monthly.isSmallAccount
      : prices.grow.yearly.isSmallAccount;
    growDiscount = isMonthly ? discounts.grow.default : discounts.grow.yearly;
    promotion = specialDiscounts[0];
  }

  // From India - applied only on yearly plans
  if (
    !isMonthly &&
    isFromIndia &&
    (!discount || discount == discounts.india.yearly)
  ) {
    startPlanPrice = prices.start.yearly.forIndian;
    growPlanPrice = prices.grow.yearly.forIndian;
    enterprisePlanPrice = prices.enterprise.yearly.forIndian;
    //@ts-ignore
    isSmallAccount = false;
    discount = discounts.india.yearly;
    growDiscount = discounts.india.yearly;
  }

  // if there is a discount, try to customize the page
  if (promotion && (!promotion.monthlyOnly || isMonthly)) {
    startPlanPrice = promotion.startPriceOverride ?? startPlanPrice;
    growPlanPrice = promotion.growPriceOverride ?? growPlanPrice;
    specialNoticeStart = promotion.specialNoticeStart ?? "";
    specialNoticeGrow = promotion.specialNoticeGrow ?? "";
    discount = originalDiscount;
  }

  const isPayingCustomer =
    !getAccount(session)?.subStatus?.includes("FreeTrial");
  const isTargettedUser =
    activeCampaign?.showItTo?.some(
      (s) => planAndTargetUsersMapping[s] === getPlan(session?.user)
    ) || false;
  if (isPayingCustomer && isTargettedUser && activeCampaign) {
    enterprisePlanPrice = 99;
  }

  const onClickStartFreeTrial = () => {
    console.log("click start trial");
  };

  // console.log({specialGrowDiscount});

  const getBanner = () => {
    // if (!isFromIndia && !globalPromotion) return;
    if (!globalPromotion) return;

    let promo;
    // isFromIndia = true;

    // if (isFromIndia)
    //   promo = (
    //     <Text fontWeight="medium" as="i">
    //       We apply parity pricing for our beloved customers from India 🇮🇳. Enjoy
    //       a 50% discount when choosing annual billing.
    //     </Text>
    //   );
    // else if (globalPromotion)
    promo = globalPromotion.message;

    return (
      <Box px={{ base: "6", md: "8" }} marginTop={{ base: "0", lg: "0" }} p={5}>
        {/* <Box> */}
        <Box
          key="banner"
          id="banner"
          justifyContent="center"
          border="4px"
          maxWidth="lg"
          margin="auto"
          borderRadius="xl"
          borderColor="#da5630"
          padding="2"
          textAlign="center"
        >
          {promo}
        </Box>
      </Box>
    );
  };

  // console.log('plans - discount:', discount)

  return (
    <Box
      key="plans-root"
      id="plans-root"
      display="flex"
      justifyContent="center"
      mt={4}
    >
      <Stack id="plans">
        {getBanner()}
        <Center mt={{ base: isFromIndia ? "10" : "-2", lg: "-2" }}>
          <Grid
            mt={[0, 0, 6]}
            mb={10}
            templateColumns={{ lg: "repeat(3, 1fr)", md: "repeat(1, 1fr)" }}
            columnGap={6}
            rowGap={4}
            alignItems="flex-start"
          >
            <PricingCard1
              startPlanPrice={startPlanPrice}
              specialNoticeStart={specialNoticeStart}
              onClickStartFreeTrial={onClickStartFreeTrial}
              discount={discount}
              billingFrequency={billingFrequency}
              customCancelUrl={customCancelUrl}
            />
            <PricingCard2
              growPlanPrice={growPlanPrice}
              growDiscount={growDiscount}
              onClickStartFreeTrial={onClickStartFreeTrial}
              billingFrequency={billingFrequency}
              customCancelUrl={customCancelUrl}
              discount={discount}
              specialNoticeStart={specialNoticeStart}
              startPlanPrice={startPlanPrice}
              withCounter={false}
              poweredByGPT4
              includesChatAssist
            />
            <PricingCard3
              onClickStartFreeTrial={onClickStartFreeTrial}
              billingFrequency={billingFrequency}
              customCancelUrl={customCancelUrl}
              discount={
                isMonthly &&
                isPayingCustomer &&
                isTargettedUser &&
                activeCampaign
                  ? "ENTERPRISE99"
                  : discount
              }
              discountedFrom={
                isMonthly &&
                isPayingCustomer &&
                isTargettedUser &&
                activeCampaign
                  ? "199"
                  : ""
              }
              specialNoticeStart={specialNoticeStart}
              startPlanPrice={startPlanPrice}
              enterprisePlanPrice={enterprisePlanPrice}
              poweredByGPT4
              includesChatAssist
            />
          </Grid>
        </Center>
      </Stack>
    </Box>
  );

  // return (
  //   <Box
  //     key="plans-root"
  //     id="plans-root"
  //     display="flex"
  //     justifyContent="center"
  //     mt={10}
  //     mb={10}
  //   >
  //     <Stack id="plans">
  //       {/* {getBanner()} */}
  //       <Center mt={{ base: isFromIndia ? "10" : "-2", lg: "-2" }}>
  //         <Grid
  //           mt={10}
  //           mb={10}
  //           // templateRows="repeat(2, 1fr)"
  //           // templateColumns="repeat(6, 1fr)"
  //           templateColumns={{ lg: "repeat(3, 1fr)", md: "repeat(1, 1fr)" }}
  //           // templateColumns={{sm: 6, md: 6}}
  //           columnGap={10}
  //           rowGap={10}
  //           m={4}
  //           // maxW="800px"
  //           alignItems="flex-start"
  //         >
  //           <GridItem mb={10} colSpan={1}>
  //             <PricingCard
  //               discount={discount}
  //               bg={mode("gray.200", "gray.600")}
  //               color={mode("gray.900", "white")}
  //               billingFrequency={billingFrequency}
  //               name="DISCOVER"
  //               plan="start"
  //               description="Write great content 10x faster"
  //               price={startPlanPrice}
  //               specialNotice={specialNoticeStart}
  //               discountedFrom={startPlanPrice !== 49 ? "49" : ""}
  //               featureIntro="Includes:"
  //               features={
  //                 [
  //                   // { title: "Over 2M viral tweets library" },
  //                   // {
  //                   //   title:
  //                   //     "10,000+ hand-picked viral tweets for every use-case",
  //                   // },
  //                   // { title: "Personalized tweet inspirations (🤖 )" },
  //                   // { title: "Search any topic or @handle" },
  //                   // { title: "Save posts to collections" },
  //                   // { title: "Tweets & threads scheduling" },
  //                   // { title: "Queue system for your post agenda" },
  //                   // { title: "Evergreen: re-use your best content" },
  //                   // { title: "Growth features (auto-retweet & auto-plug)" },
  //                   // { title: "Auto-DM" },
  //                   // { title: "Auto-plug" },
  //                   // { title: "Auto-retweet" },
  //                   // { title: "Hide URL previews" },
  //                   // { title: "AI-powered Analytics Dashboard" },
  //                   // { title: "Find relevant tweets to engage with" },
  //                   // { title: "Add unlimited Twitter accounts" },
  //                 ]
  //               }
  //               //@ts-ignore
  //               onClickStartFreeTrial={onClickStartFreeTrial}
  //               customCancelUrl={customCancelUrl}
  //             />
  //           </GridItem>
  //           <GridItem mb={10} colSpan={1}>
  //             {
  //               // isSmallAccount && promotion && (
  //               promotion?.message && (
  //                 <Center>
  //                   <Tag
  //                     mb={5}
  //                     p={2}
  //                     pl={4}
  //                     pr={4}
  //                     bg={mode("gray.800", "white")}
  //                     borderRadius="full"
  //                     size="md"
  //                   >
  //                     <TagLabel
  //                       fontSize="md"
  //                       fontWeight="400"
  //                       color={mode("white", "gray.700")}
  //                     >
  //                       {/* {"< 1000 followers? "}<b>Get 40% off GROW</b> */}
  //                       {promotion?.message}
  //                     </TagLabel>
  //                   </Tag>
  //                 </Center>
  //               )
  //             }
  //             <PricingCard
  //               discount={growDiscount}
  //               bg={mode("gray.600", "white")}
  //               color={mode("white", "gray.700")}
  //               billingFrequency={billingFrequency}
  //               popular={true}
  //               name="GROW"
  //               plan="grow"
  //               description="Unlock the power of AI."
  //               price={growPlanPrice}
  //               featureIntro="Includes everything in DISCOVER"
  //               discountedFrom={"99"}
  //               specialNotice={specialNoticeGrow}
  //               // specialNotice={isSmallAccount ? "Discount less than 1000 followers" : ""}
  //               features={[]}
  //               customFeature={
  //                 <Box maxW="340px">
  //                   <Center>Includes everything in DISCOVER</Center>
  //                   <Center
  //                     fontSize="50px"
  //                     fontWeight="400"
  //                     color="gray.600"
  //                     m={2}
  //                   >
  //                     +
  //                   </Center>
  //                   <Flex
  //                     p={5}
  //                     rounded="xl"
  //                     border={
  //                       "solid 2px " +
  //                       mode(theme.colors.gray[600], theme.colors.gray[200])
  //                     }
  //                     bg={mode("white", "#1E1E1E")}
  //                     flexDirection="column"
  //                   >
  //                     <Center mb={4}>
  //                       <Text>🤖 &nbsp;&nbsp;AI WRITER</Text>
  //                     </Center>
  //                     {/* <Center m={5} color="gray.500" fontSize="sm">
  //                                               <Text>Unlimited generations</Text>
  //                                           </Center> */}
  //                     {[
  //                       "Daily AI-generated tweets",
  //                       "Re-write tweets you like w/ AI",
  //                       // "Unlimited use",
  //                       "Generate thread ideas & hooks",
  //                       // "Generate thread hooks",
  //                       "Let the AI finish your posts",
  //                     ].map((f, index) => (
  //                       <Flex key={index} m={2}>
  //                         <Flex
  //                           mr={2}
  //                           rounded="full"
  //                           w={6}
  //                           h={6}
  //                           color={mode("white", "#1E1E1E")}
  //                           alignItems="center"
  //                           justifyContent="center"
  //                         >
  //                           {/* <Text>{index + 1}</Text> */}
  //                           <Icon
  //                             as={MdCheckCircle}
  //                             color={mode("gray.600", "gray.100")}
  //                             fontSize="20px"
  //                           />
  //                         </Flex>
  //                         <Text>{f}</Text>
  //                       </Flex>
  //                     ))}
  //                   </Flex>
  //                   <Center
  //                     fontSize="50px"
  //                     fontWeight="400"
  //                     color="gray.600"
  //                     m={2}
  //                   >
  //                     +
  //                   </Center>
  //                   <Flex
  //                     p={5}
  //                     rounded="xl"
  //                     border={
  //                       "solid 2px " +
  //                       mode(theme.colors.gray[600], theme.colors.gray[200])
  //                     }
  //                     bg={mode("white", "#1E1E1E")}
  //                     flexDirection="column"
  //                   >
  //                     <Center mb={4}>
  //                       <Text>🙋 &nbsp;&nbsp;TWITTER CRM</Text>
  //                     </Center>
  //                     {/* <Center m={5} color="gray.500" fontSize="sm">
  //                                               <Text>Unlimited generations</Text>
  //                                           </Center> */}
  //                     {[
  //                       "Manage lists of people",
  //                       "Import from tweets & DM interactions",
  //                       "Engage to those people",
  //                     ].map((f, index) => (
  //                       <Flex key={index} m={2}>
  //                         <Flex
  //                           mr={2}
  //                           rounded="full"
  //                           w={6}
  //                           h={6}
  //                           color={mode("white", "#1E1E1E")}
  //                           alignItems="center"
  //                           justifyContent="center"
  //                         >
  //                           {/* <Text>{index + 1}</Text> */}
  //                           <Icon
  //                             as={MdCheckCircle}
  //                             color={mode("gray.600", "gray.100")}
  //                             fontSize="20px"
  //                           />
  //                         </Flex>
  //                         <Text>{f}</Text>
  //                       </Flex>
  //                     ))}
  //                   </Flex>
  //                 </Box>
  //               }
  //               //@ts-ignore
  //               onClickStartFreeTrial={onClickStartFreeTrial}
  //               customCancelUrl={customCancelUrl}
  //             />
  //           </GridItem>
  //           <GridItem colSpan={1}>
  //             <PricingCard
  //               discount={discount}
  //               bg={mode("gray.200", "gray.600")}
  //               color={mode("gray.900", "white")}
  //               billingFrequency={billingFrequency}
  //               name="ENTERPRISE"
  //               plan="enterprise"
  //               description="Do less. Get more."
  //               price={enterprisePlanPrice}
  //               featureIntro="Includes everything in GROW"
  //               discountedFrom={enterprisePlanPrice !== 200 ? "200" : ""}
  //               // type="agency"
  //               features={
  //                 [
  //                   // { title: "Unlimited AI generations" },
  //                   // {
  //                   //   title:
  //                   //     "Custom AI model to get AI-generated tweets adapted to your niche and audience",
  //                   // },
  //                   // {
  //                   //   title:
  //                   //     "Engage with the world at light speed with AI-generated replies",
  //                   // },
  //                   // { title: "Find email addresses of your Twitter contacts" },
  //                 ]
  //               }
  //               customFeature={
  //                 <Box>
  //                   <Center>Includes everything in GROW</Center>
  //                   <Center
  //                     fontSize="50px"
  //                     fontWeight="400"
  //                     color="gray.600"
  //                     m={2}
  //                   >
  //                     +
  //                   </Center>
  //                 </Box>
  //               }
  //               //@ts-ignore
  //               onClickStartFreeTrial={onClickStartFreeTrial}
  //               customCancelUrl={customCancelUrl}
  //             />
  //           </GridItem>
  //         </Grid>
  //       </Center>
  //     </Stack>
  //   </Box>
  // );
};
